import React from "react";
import "../css/About.css";

const About2 = () => {
  return (
    <div className="about2">

      {/* ---------------- HERO BANNER ---------------- */}
      <section className="about2-hero">
        <img 
          src="https://images.unsplash.com/photo-1579758629938-03607ccdbaba?auto=format&fit=crop&w=1600&q=80"
          alt="About FLEXOR"
        />
        <div className="about2-hero-text">
          <h1>THE FLEXOR STANDARD</h1>
          <p>Where intention shapes ability.</p>
        </div>
      </section>


      {/* ---------------- SECTION 1 — BRAND STATEMENT ---------------- */}
      <section className="about2-statement">
        <h2>
          Training isn't repetition —<br />
          <span>it's evolution.</span>
        </h2>
        <p>
          FLEXOR was created with a singular purpose: to redefine how humans move,
          think, and elevate their bodies. We focus on long-term durability,
          biomechanics, intelligent progression, and emotional resilience.
        </p>
      </section>


      {/* ---------------- SECTION 2 — IMAGE + TEXT SPLIT ---------------- */}
      <section className="about2-split">
        <div className="split-img">
          <img 
            src="https://images.pexels.com/photos/136404/pexels-photo-136404.jpeg"
            alt="FLEXOR philosophy"
          />
        </div>

        <div className="split-text">
          <h3>Precision Creates Power</h3>
          <p>
            Good training isn't about doing more — it's about doing better.  
            FLEXOR athletes learn to master posture, breathing, stability,
            and neuromuscular control before adding load or intensity.
          </p>
        </div>
      </section>


      {/* ---------------- SECTION 3 — PILLARS GRID ---------------- */}
      <section className="about2-pillars">
        <h2>THE FLEXOR PILLARS</h2>

        <div className="pillars-grid">
          <div className="pillar">
            <h4>Biomechanics</h4>
            <p>Move the way the body was engineered to move — efficiently and safely.</p>
          </div>
          <div className="pillar">
            <h4>Mindset</h4>
            <p>Calmness and control form the backbone of elite performance.</p>
          </div>
          <div className="pillar">
            <h4>Consistency</h4>
            <p>Progress isn't an event. It's the accumulated results of daily practice.</p>
          </div>
          <div className="pillar">
            <h4>Strength Culture</h4>
            <p>A balanced combination of structure, energy, intensity, and intention.</p>
          </div>
        </div>
      </section>


      {/* ---------------- SECTION 4 — FULL WIDTH STATEMENT ---------------- */}
      <section className="about2-wide">
        <h2>
          “Your potential expands every time you choose discipline over comfort.”
        </h2>
      </section>


      {/* ---------------- SECTION 5 — TEAM SHOWCASE ---------------- */}
      <section className="about2-team">
        <h2>THE FLEXOR TEAM</h2>
        <p className="team-sub">
          Built by specialists in athletic performance, human movement,
          and modern conditioning.
        </p>

        <div className="team-grid">
          <div className="coach-card">
            <div className="coach-img img1"></div>
            <h4>Adrian Cole</h4>
            <p>Head Performance Architect</p>
          </div>

          <div className="coach-card">
            <div className="coach-img img2"></div>
            <h4>Mila Reyes</h4>
            <p>Mobility & Movement Specialist</p>
          </div>

          <div className="coach-card">
            <div className="coach-img img3"></div>
            <h4>Jordan Hale</h4>
            <p>Strength & Conditioning Expert</p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About2;
